module.exports = __webpack_public_path__ + "static/media/Raw.ca5acf54.jpg";